import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { Container } from "react-bootstrap";
import { apiRequest } from "../services/apiService";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

export default function List() {
  const navigate = useNavigate();
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiRequest("get-queries", "GET");
        console.log("list response: ", response);
        if (Array.isArray(response)) {
          setOptions(response);
        } else {
          setOptions([]);
        }
      } catch (error) {
        console.log("Błąd pobierania danych:", error.message);
      }
    };
    fetchData();
  }, []);

  // Grupowanie elementów po polu "stage"
  const groupedOptions = options.reduce((acc, item) => {
    const groupKey = item.stage || "Inne";
    if (!acc[groupKey]) {
      acc[groupKey] = [];
    }
    acc[groupKey].push(item);
    return acc;
  }, {});

  return (
    <Box sx={{ backgroundColor: "#f8f9fa", minHeight: "100vh", pb: 5 }}>
      <Container style={{ marginTop: "40px", maxWidth: "850px" }}>
        <Typography
          variant="h2"
          sx={{
            marginBottom: 4,
            fontWeight: 800,
            color: "#1a237e",
            letterSpacing: "-0.5px",
            fontSize: "2rem",
          }}
        >
          Lista pytań weryfikacyjnych
        </Typography>

        {Object.entries(groupedOptions).map(
          ([stageName, items], groupIndex) => (
            <Box key={groupIndex} sx={{ marginBottom: 5 }}>
              <Typography
                variant="overline"
                sx={{
                  fontSize: "0.95rem",
                  fontWeight: "bold",
                  color: "primary.main",
                  display: "block",
                  marginBottom: 2,
                  borderLeft: "4px solid",
                  paddingLeft: 2,
                  lineHeight: 1.4,
                }}
              >
                {stageName}
              </Typography>

              {items.map((item, itemIndex) => (
                <Paper
                  key={itemIndex}
                  elevation={0}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "16px 24px",
                    marginBottom: 1.5,
                    borderRadius: "16px",
                    border: "1px solid #e0e0e0",
                    backgroundColor: "#fff",
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.01)",
                      boxShadow: "0px 10px 20px rgba(0,0,0,0.05)",
                      borderColor: "primary.light",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2.5,
                      width: "100%",
                    }}
                  >
                    <HelpOutlineIcon
                      color="primary"
                      sx={{ fontSize: 28, flexShrink: 0 }}
                    />

                    <Box sx={{ width: "100%" }}>
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: "1rem",
                          fontWeight: 600,
                          color: "#333",
                        }}
                      >
                        {item.query}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              ))}
            </Box>
          ),
        )}
      </Container>
    </Box>
  );
}
